import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

const Header = lazy(() => import("./components/Header"));
const Footer = lazy(() => import("./components/Footer"));
const AppRoutes = lazy(() => import("./Routes"));
const PdfRouter = lazy(() => import("./pdf/routers/pdfRoutes"));

function App() {
  return (
    <Router>
      <Suspense
        fallback={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              textAlign: "center",
            }}
          >
            <img src="/loader.gif" alt="Loading..." />
          </div>
        }
      >
        <Header />
        <div>
          <AppRoutes />
          <PdfRouter />
        </div>
        <Footer />
      </Suspense>
    </Router>
  );
}

export default App;
